/* eslint-disable */

import React from 'react';

import { query } from './query';
import DataTable from '../../../../components/Datatable';
import { COLUMNS } from './keys';
import Search from '../../../../components/Search';
import { scrollForTable } from '../../../../components/Datatable/utils';
import Component from '../../../../components/Component';
import Loading from '../../../../components/Loading';
import ExtraButtons from './ExtraBtns';
import AdditionalBox from './additionalBox';
import { withTranslation } from 'react-i18next';

class YearKeywords extends Component {
    constructor(props) {
        super();
        if (!props.data) this.query = query({ offset: 0, search: null });
        this.offsetStep = 1000;

        this.getData = this.getData.bind(this);
        this.onSearch = this.onSearch.bind(this);
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item.keyword?.toLowerCase().includes(search.toLowerCase()));
    }

    async getData(value, search) {
        this.query = query({
            offset: 0,
            year: value,
            search: search ?? this.state.search,
        });
        this.query.bind(this.setState.bind(this));
        this.setState({ year: value, data: [] });

        await this.query.update();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.data && JSON.stringify(this.state.data) !== JSON.stringify(prevState.data)) {
            this.props.updateDatas({ key: 'yearKeywords', value: this.state.data });
        }
    }

    onSearch(value) {
        this.setState({
            search: value,
        });
        this.getData(this.state.year, value);
    }

    render() {
        const { t } = this.props;
        const data = this.state.data?.length ? this.state.data : this.props.data;
        if ((!data || !data.length) && this.state.loading) return <Loading padding={10} />;
        const sortFns = {
            keyword: (array) => array.sort((a, b) => a.keyword.localeCompare(b.keyword)),
            seen: (array) =>
                array.sort((a, b) => new Date(a.firstSeen?.value) - new Date(b.firstSeen?.value)),
            maxClicks: (array) => array.sort((a, b) => a.maxClicks - b.maxClicks),
            avgClicks: (array) => array.sort((a, b) => a.avgClicks - b.avgClicks),
            avgURLs: (array) => array.sort((a, b) => a.avgURLs - b.avgURLs),
            avgPosition: (array) => array.sort((a, b) => a.avgPosition - b.avgPosition),
            impressions: (array) => array.sort((a, b) => a.impressions - b.impressions),
            avgCTR: (array) => array.sort((a, b) => a.avgCTR - b.avgCTR),
        };

        const customeSearch = (
            <Search
                onSubmit={this.onSearch}
                placeholder="Search for items"
                defaultValue={this.state.search}
            />
        );

        const additionalBox = () => <AdditionalBox />;

        const extraBtns = () => (
            <ExtraButtons
                lastYear={this.props.lastYear}
                t={t}
                currentYear={this.props.currentYear}
            />
        );
        return (
            <>
                <DataTable
                    nodes={data}
                    sortFns={sortFns}
                    COLUMNS={COLUMNS}
                    fileName="Year Keywords"
                    searchFunction={this.searchFunction}
                    defaultSortKey="maxClicks"
                    additionalBox={additionalBox}
                    header={`"Year" Keywords`}
                    forceRun={this.forceRun}
                    customeSearch={customeSearch}
                    extraBtns={extraBtns}
                    customEmptyMessage={this.props.message}
                    viewAllLink={`/domains/${window.info.id}/gsc-reports/year-keywords/`}
                    showViewAll={true}
                    additionalStyles={{
                        Table: `
                                    --data-table-library_grid-template-columns : minmax(200px, 3fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) !important;
                                   ${scrollForTable}
                                `,
                        BaseCell: ` font-family: 'Raleway';
                                        font-weight: 500;
                                        font-size: 16px;
                                        line-height: 19px;
                                        padding: 16px 10px !important;
                                        color: #0D182C;
                                    
                                    
                                        &.underline {
                                            text-decoration: underline;
                                        }
                                        `,
                    }}
                />
                {(!data || !data?.length) && !this.state.filter && this.props.message && (
                    <div className="mt-10">
                        <div className="redirect-button">
                            <a
                                className="button button-filled button-primary"
                                href="/customers/change_plan/?without_basic=True"
                            >
                                {t('opportunities.adjust_plan')}
                            </a>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

export default withTranslation()(YearKeywords);
